import React from 'react'
import PropTypes from 'prop-types'

import { classNames } from 'utils/utils'
import strings from 'utils/strings'

import { SelectMenu } from 'components/patterns/Inputs'

import { POWER_NET_LEVELS } from 'constants/featureOutputs'
import { powerNetLevels } from 'i18n/displayConstants/featureOutputs'

import outputSchema from 'schemas/validation/feature/outputSchema'
import { schemaProp } from 'schemas/validation'

import PowerNetLevelTable from './PowerNetLevelTableSVG.jsx'

const rule = schemaProp(outputSchema)

const PowerNetLevelEditor = ({ powerNetLevel, handleChange, className }) => {
  const selectOptions = POWER_NET_LEVELS.map((level) => ({
    key: level,
    value: level,
    title: `${level}: ${powerNetLevels(level)}`,
  }))

  return (
    <SelectMenu
      className={classNames('form-field', className)}
      label={strings.power_net_level}
      tooltip={<PowerNetLevelTable />}
      options={selectOptions}
      value={powerNetLevel}
      onChange={handleChange}
      name={strings.power_net_level}
      rules={rule('powerNetLevel')}
      tooltipAutoWidth
      isSVGTooltip
      data-testid="power-net-level"
    />
  )
}

PowerNetLevelEditor.propTypes = {
  className: PropTypes.string,
  powerNetLevel: PropTypes.number,
  handleChange: PropTypes.func,
}

export default PowerNetLevelEditor
